import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { KioskLoyaltyConnectionBlockConfig } from '@front-platform/content-builder';
import { kioskLoyaltyConnectionBlockResolveConfig } from '@front-platform/content-builder';
import { Component, HostBinding, input } from '@angular/core';
import { IContentBuilderFieldColor } from '@core/models/content-builder-fields.model';
export interface KioskLoyaltyConnectionBlockRuntimeConfig {
  'text_color'?: IContentBuilderFieldColor | undefined;
  'background_color'?: IContentBuilderFieldColor | undefined;
  'cards_color'?: IContentBuilderFieldColor | undefined;
}

export type KioskLoyaltyConnectionBlockConfigInput = Partial<
  Omit<KioskLoyaltyConnectionBlockConfig, keyof KioskLoyaltyConnectionBlockRuntimeConfig> &
    KioskLoyaltyConnectionBlockRuntimeConfig
>;
export type KioskLoyaltyConnectionBlockResolvedConfig = Omit<
  KioskLoyaltyConnectionBlockConfig,
  keyof KioskLoyaltyConnectionBlockRuntimeConfig
> &
  Partial<KioskLoyaltyConnectionBlockRuntimeConfig>;
export interface KioskLoyaltyConnectionBlockContract extends ConfigComponentContract<
  KioskLoyaltyConnectionBlockConfigInput,
  KioskLoyaltyConnectionBlockResolvedConfig
> {}

@Component({
  selector: 'app-kiosk-loyalty-connection-block',
  templateUrl: './kiosk-loyalty-connection-block.component.html',
  standalone: false,
})
export class KioskLoyaltyConnectionBlockComponent implements KioskLoyaltyConnectionBlockContract {
  readonly config = input<KioskLoyaltyConnectionBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    KioskLoyaltyConnectionBlockConfig,
    KioskLoyaltyConnectionBlockRuntimeConfig
  >(kioskLoyaltyConnectionBlockResolveConfig, () => ({ config: this.config() }));
  get textColor(): IContentBuilderFieldColor | undefined {
    return this.resolvedConfig()['text_color'] as unknown as IContentBuilderFieldColor | undefined;
  }
  get backgroundColor(): IContentBuilderFieldColor | undefined {
    return this.resolvedConfig()['background_color'] as unknown as
      IContentBuilderFieldColor | undefined;
  }
  get cardsColor(): IContentBuilderFieldColor | undefined {
    return this.resolvedConfig()['cards_color'] as unknown as IContentBuilderFieldColor | undefined;
  }
  get title(): string | undefined {
    return this.resolvedConfig()['title'] as unknown as string | undefined;
  }
  get firstCardLink(): string | undefined {
    return this.resolvedConfig()['first_card_link'] as unknown as string | undefined;
  }
  get firstCardLabel(): string | undefined {
    return this.resolvedConfig()['first_card_label'] as unknown as string | undefined;
  }
  get secondCardLink(): string | undefined {
    return this.resolvedConfig()['second_card_link'] as unknown as string | undefined;
  }
  get secondCardLabel(): string | undefined {
    return this.resolvedConfig()['second_card_label'] as unknown as string | undefined;
  }
  get headingTextColor(): IContentBuilderFieldColor {
    return this.resolvedConfig()['heading_text_color'] as unknown as IContentBuilderFieldColor;
  }
  get mainCardBackgroundColor(): IContentBuilderFieldColor {
    return this.resolvedConfig()[
      'main_card_background_color'
    ] as unknown as IContentBuilderFieldColor;
  }
  get mainCardTextColor(): IContentBuilderFieldColor {
    return this.resolvedConfig()['main_card_text_color'] as unknown as IContentBuilderFieldColor;
  }
  get secondaryCardBackgroundColor(): IContentBuilderFieldColor {
    return this.resolvedConfig()[
      'secondary_card_background_color'
    ] as unknown as IContentBuilderFieldColor;
  }
  get secondaryCardTextColor(): IContentBuilderFieldColor {
    return this.resolvedConfig()[
      'secondary_card_text_color'
    ] as unknown as IContentBuilderFieldColor;
  }
  get displayThirdCard(): boolean {
    return this.resolvedConfig()['display_third_card'] === true;
  }
  get thirdCardLink(): string | undefined {
    return this.resolvedConfig()['third_card_link'] as unknown as string | undefined;
  }
  get thirdCardLabel(): string | undefined {
    return this.resolvedConfig()['third_card_label'] as unknown as string | undefined;
  }
  get thirdCardBackgroundColor(): IContentBuilderFieldColor {
    return this.resolvedConfig()[
      'third_card_background_color'
    ] as unknown as IContentBuilderFieldColor;
  }
  get thirdCardTextColor(): IContentBuilderFieldColor {
    return this.resolvedConfig()[
      'third_card_text_color'
    ] as unknown as IContentBuilderFieldColor;
  }

  @HostBinding('class') classes = 'h-full flex text-center';
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(KioskLoyaltyConnectionBlockComponent, {
  'keyAliases': {},
});
